<template>
    <b-modal
        id="about-us-more-info"
        centered
        hide-footer
        title="More Info"
        content-class="border-0 overflow-hidden"
        header-class="border-bottom-0 p-0"
        title-class="w-100"
        scrollable>
        <template #modal-header-close>
            <img src="@/assets/images/close.svg" alt="Close">
        </template>
        <template #modal-title>
            <img :src="content.image" :alt="content.title" class="img-fluid w-100 modal-image">
        </template>
        <h4> {{ content.title }} </h4>
        <div v-html="content.more_info"></div>
    </b-modal>
</template>

<script>
export default {
    name: "MoreInfoModal",
    props: ["content"]
}
</script>

<style lang="scss">
#about-us-more-info {
    .close {
        outline: 0;
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .modal-content {
        border-radius: 23px;
    }
    .modal-image {
        object-fit: cover;
    }
    h4 {
        @extend .mainFontBold;
        font-size: 20px;
        color: #2F3941;
    }
}
</style>
